<template>
  <div>
    <div v-if="arr.length" class="ma-auto" >
      <div class="mb-5">
        <div v-if="!done" class="text-h5">
          <v-progress-circular indeterminate size="30"></v-progress-circular>
        </div>
        <div v-else-if="indexSelect == null" class="text-x4 fw-6 ta-center">
          Нажмите на изображение
        </div>
        <div v-else class="text-x4 fw-6 ta-center">
          Теперь нажми чтобы соединить это
        </div>
      </div>
      <div class="row">
        <div
          class="d-flex col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
          v-for="(item, index) in arr" :key="index">
          <div
            style="border-radius: 15px; min-height: 200px; width: 100%;"
            :style="{
              border: `5px solid ${
                answerData[index] && answerData[index]['color']
                  ? answerData[index]['color']
                  : indexSelect != null && indexSelect == index
                  ? colors[indexSelect]
                  : '#fff'
              }`,
            }"
            class="o-hidden"
          >
            <div class="h-10" @click="setItem(index)" role="button">
              <span :ref="`item_${index}`" class="question_glue_item"></span>
              <div class="flex fd-column h-10 question-item__wrapper bg-color-white">
                <div class="question__title flex ai-center p-x-3 p-y-3 jc-start ta-left" 
                    :class="{'p-r-10': item.audio_document.file}" style="min-height: 60px;"
                    v-if="item['title']">
                  <span v-html="$options.filters.mathformat(item['title'])"></span>
                </div>
                <div>
                  <v-img :src="item['img']" height="200px" v-if="item['img']"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ta-center m-t-10 btn-content">
        <v-btn :loading="loading" @click="answer" class="mt-8" large color="info">
          Ответить на вопрос
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  props: {
    data: Object,
  },

  async created() {
    this.question = await JSON.parse(JSON.stringify(this.data));

    this.prevArr = await JSON.parse(JSON.stringify(this.data["answers"]));

    this.arr = await JSON.parse(JSON.stringify(this.data["answers"])).sort(() => Math.random() - 0.5);
    
    this.prevArr = this.arr;
  },

  async mounted() {
    
    try {
      this.LeaderLine = require("leader-line-vue").default;
    } catch (error) {
      this.LeaderLine = null;
    }
    this.done = true;
  },
  beforeDestroy() {
    // document.querySelectorAll(".leader-line").forEach(el => el.remove());
    Object.keys(this.answerData).map((obKey) => {
      try {
        this.answerData[obKey]["line"].remove();
      } catch (error) {}
    });
  },
  data() {
    return {
      colors: [
        "#271b8f",
        "#ff4c00",
        "#ff961d",
        "#4f5d9a",
        "#eb265d",
        "#ffd133",
        "#6500fd",
        "#08bfc6",
        "#e8e12d",
        "#057bff",
        "#df2fb8",

        "#271b8f",
        "#ff4c00",
        "#ff961d",
        "#4f5d9a",
        "#eb265d",
        "#ffd133",
        "#6500fd",
        "#08bfc6",
        "#e8e12d",
        "#057bff",
        "#df2fb8",
      ],
      arr: [],
      prevArr: [],
      question: {},
      loading: false,
      done: false,
      answerData: {},
      indexSelect: null,
      LeaderLine: null,
    };
  },

  methods: {
    play(item, arrItems) {
      let audio = item.audio_document
      arrItems.forEach((el)=>{
        if(el.track)
          el.track.pause()
        el.audio_document.play = false
      })
      audio.play = true;
      item.track = new Audio(audio.file);
      
      item.track.play();
      console.log(document.querySelectorAll("audio"))
      item.track.onended = function () {
        audio.play = false;
      };
    },
    pause(item) {
      let audio = item.audio_document
      audio.play = false;
      item.track.pause();
    },
    async setItem(index) {
      try {
        if (this.indexSelect == index) {
          return false;
        }
        if (await this.answerData[index]) {
          try {
            await this.answerData[index]["line"].remove();
          } catch (error) {}
          this.$delete(this.answerData, this.answerData[index]["connector"]);
          this.$delete(this.answerData, index);
          return false;
        }

        if ((await this.indexSelect) != null) {
          await this.setLine(index);
        } else {
          this.indexSelect = await index;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async answer() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    },

    setLine(index) {
      try {
        const color = this.colors[this.indexSelect];

        const line = this.LeaderLine.setLine(
          this.$refs[`item_${this.indexSelect}`][0],
          this.$refs[`item_${index}`][0],
          {
            dash: { animation: true },
            startPlug: "disc",
            endPlug: "disc",
            color: color,
            size: 8,
          }
        );

        this.$set(this.answerData, this.indexSelect, {
          connector: index,
          color: color,
          line: line,
        });

        this.$set(this.answerData, index, {
          connector: this.indexSelect,
          color: color,
          line: line,
        });
      } catch (error) {}

      this.indexSelect = null;
    },

    setInitLine(index, index2) {
      const color = this.colors[index2];

      try {
        // console.log('index2', this.$refs[`item_${index2}`]);
        // console.log('index', this.$refs[`item_${index}`]);

        const line = this.LeaderLine.setLine(
          this.$refs[`item_${index2}`][0],
          this.$refs[`item_${index}`][0],
          {
            dash: { animation: true },
            startPlug: "disc",
            endPlug: "disc",
            color: color,
            size: 8,
          }
        );

        this.$set(this.answerData, index2, {
          connector: index,
          color: color,
          line: line,
        });

        this.$set(this.answerData, index, {
          connector: index2,
          color: color,
          line: line,
        });
      } catch (error) {
        console.log(error);
      }

      this.indexSelect = null;
    },
  },
};
</script>
